import axiosApiInstance from '../axios/axiosApiInstance';

export const fetch = async () => {
  const response = await axiosApiInstance.get(`statement/balance`);

  return response?.data || { currentBalance: 0, pendingCreditRecharge: 0 };
};
